<template>
  <div class="copilot">
    <!-- AI开发测试开始 -->
    <transition name="ai1">
      <div
        v-if="aiShow"
        :class="isMobile?'aibox_m':'aibox'"
        :style="{ width: !isMobile? currentW + 'px': '' }"
      >
        <transition name="left">
          <div v-if="leftDialogbox" class="left">
            <div class="addchat">
              <button class="addbtn">新建对话</button>
            </div>
          </div>
        </transition>
        <div v-if="!isMobile" class="border" v-dragAbout></div>
        <div class="right">
          <transition name="close">
            <div v-if="messageTipShow" class="messageTip">{{ messageTip }}</div>
          </transition>
          <div class="title">
            <div class="chatnum">
              <span @click="upgrade">增量升级</span>
              互动次数: {{chatInfo.packageNum}}/{{chatInfo.packageSurplus}}
            </div>
            <!-- FOSHO AFF Copilot -->
            <el-tooltip class="item" effect="dark" content="最小化" placement="bottom-end">
              <i class="el-icon-minus top-minus" style @click="initAI1"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="关闭并退出对话" placement="bottom-end">
              <i class="el-icon-close top-close" style @click="closeAi"></i>
            </el-tooltip>
          </div>
          <div class="contentbox" ref="contentbox">
            <div id="chat-dialog" class="chat-dialog" ref="chatDialogRef">
              <div id="chat-list" class="chat-list" ref="chatListRef">
                <div
                  v-for="(item, index) in chatList"
                  :key="index"
                  :class="item.type === 'bot' ? 'botbox' : 'userbox'"
                >
                  <div
                    :class="item.type === 'bot' ? 'bot tastrule_center' : 'user tastrule_center'"
                    v-html="item.content"
                  ></div>
                  <div v-if="item.type === 'bot' && item.status" class="aiOperate">
                    <div>
                      <el-tooltip class="item" effect="dark" content="点赞" placement="top">
                        <img
                          v-if="!item.islike"
                          src="@/assets/img/copilot/like0.png"
                          @click="handleLikeOrNot(1,index)"
                        />
                        <img v-else src="@/assets/img/copilot/like1.png" />
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="点踩" placement="top">
                        <img
                          v-if="!item.isDisLike"
                          src="@/assets/img/copilot/dislike0.png"
                          @click="handleLikeOrNot(0,index)"
                        />
                        <img v-else src="@/assets/img/copilot/dislike1.png" />
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="复制" placement="top">
                        <img
                          @click="copyToClipboard(item.content)"
                          src="@/assets/img/copilot/copy.png"
                        />
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div v-if="kfCode" class="kfbox" style="width: 272px">
                  <div class="codeimg tastrule_center">
                    <p style>您的套餐已失效或互动次数已消耗完毕，请联系客服开通</p>
                    <img style="width: 150px" src="@/assets/img/home/kf2.png" alt />
                  </div>
                </div>
                <div class="loadingview" v-if="requestLoading">
                  <div class="loadingbox">
                    <div class="point1"></div>
                    <div class="point2"></div>
                    <div class="point3"></div>
                  </div>
                </div>
                <div v-if="requestEnd" class="threequestion">
                  <img src="@/assets/img/copilot/question.png" />
                  <div
                    @click="submitAutoQuestion(item)"
                    v-for="item in threeQuestions"
                    :key="item"
                  >{{item}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottombox">
            <div class="bottombox_inner">
              <el-input
                @keyup.enter.native="sendAiMsg"
                ref="aismg"
                id="msgInput"
                resize="none"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 6 }"
                :rows="3"
                maxlength="500"
                show-word-limit
                placeholder="请输入问题...(按ENTER键发送)"
                v-model="aimsg"
              ></el-input>
              <i style class="el-icon-s-promotion" @click="sendAiMsg"></i>
            </div>
            <p class="aitips">内容由AI生成，仅供参考</p>
          </div>
        </div>
      </div>
    </transition>

    <div id="aibtn3" v-if="aiShow2 && ($route.meta.keep === 2 || $route.meta.keep === 3)">
      <img id="bot" @click="initAI2" src="@/assets/img/fosho_copilot2.png" />
    </div>
  </div>
</template>
  <script>
import { EventSourcePolyfill } from "event-source-polyfill";
import util from "@/utils/util";
import { QUERYBAIDUBCE, LIKEORDISLIKE, GETTHREEQUESTION } from "@/api/personal";
export default {
  name: "copilot",
  data() {
    return {
      isMobile: false,
      // AI
      currentW: 450,
      chatInfo: {
        packageNum: null,
        packageSurplus: null
      },
      threeQuestions: [],
      kfCode: false,
      hasCoplet: false,
      aiShow: false, // ai界面显示状态
      aiShow2: true,
      textCount: 0,
      timer: null,
      chatList: [
        {
          content:
            "<P>您好，我是您的联盟精灵小F，您可以向我提出有关联盟营销的问题，我都会尽力回答哦～</p>",
          type: "bot",
          status: false
        }
      ],
      aimsg: "",
      aiRequest: false,
      requestEnd: false,
      requestLoading: false,
      leftDialogbox: false,
      messageTip: "",
      messageTipShow: false,
      sse: "",
      isNewChat: true
    };
  },
  directives: {
    dragAbout: {
      inserted(el, binding, vNode) {
        el.style.cursor = "e-resize";
        const that = vNode.context;
        document.addEventListener("selectstart", function(e) {
          e.preventDefault();
        });
        el.onmousedown = function(e) {
          let index = vNode.key;
          document.onmousemove = function(e) {
            let nw = window.innerWidth - e.clientX;
            nw = nw < 450 ? 450 : nw;
            that.currentW = nw;
          };
        };
        document.onmouseup = function() {
          document.onmousemove = document.onmousedown = null;
        };
      }
    }
  },
  created() {
    this.isMobile = util.isMobile();
    // this.queryBaiduBce();
  },
  methods: {
    closeAi() {
      this.aiShow = false;
      this.isNewChat = true;
      this.chatList = [
        {
          content:
            "<P>您好，我是您的联盟精灵小F，您可以向我提出有关联盟营销的问题，我都会尽力回答哦～</p>",
          type: "bot",
          status: false
        }
      ];
      this.requestEnd = false;
      setTimeout(() => {
        this.aiShow2 = true;
      }, 500);
    },
    initAI1() {
      this.aiShow = false;
      this.isNewChat = false;
      setTimeout(() => {
        this.aiShow2 = true;
      }, 500);
    },
    initAI2() {
      this.queryBaiduBce();
      this.aiShow2 = !this.aiShow2;
      this.aiShow = true;
    },
    tabOperate() {
      this.leftDialogbox = !this.leftDialogbox;
    },

    queryBaiduBce() {
      QUERYBAIDUBCE().then(res => {
        if (res.data.code == "success") {
          this.chatInfo = res.data.body;
        }
      });
    },
    handleLikeOrNot(type, index) {
      let question = this.chatList[index - 1].content;
      let params = {};
      if (type == 1) {
        params.question = question;
        params.likeCount = 1;
        params.dislikeCount = 0;
        LIKEORDISLIKE(params).then(res => {
          if (res.data.code == "success") {
            this.chatList[index].islike = true;
            this.chatList[index].isDisLike = false;
          }
        });
      }
      if (type == 0) {
        params.question = question;
        params.likeCount = 0;
        params.dislikeCount = 1;
        LIKEORDISLIKE(params).then(res => {
          if (res.data.code == "success") {
            this.chatList[index].islike = false;
            this.chatList[index].isDisLike = true;
          }
        });
      }
    },
    queryThreeQuestions() {
      GETTHREEQUESTION().then(res => {
        if (res.data.code == "success") {
          this.threeQuestions = res.data.body.chatFaqs;
        } else {
          this.threeQuestions = [];
        }
      });
    },
    upgrade() {
      this.kfCode = true;
    },
    submitAutoQuestion(info) {
      this.aimsg = info.trim();
      this.sendAiMsg();
    },
    // 建立长连接发送提问
    sendAiMsg(e) {
      if (this.chatInfo.packageNum < 1) {
        this.kfCode = true;
        this.aimsg = null;
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          window.event.value = false;
        }
      } else {
        this.aimsg = this.aimsg.trim();
        let aimsgData = this.aimsg;
        for (var i = 0; i < aimsgData.length; i++) {
          if (aimsgData[i] === "?") {
            aimsgData = aimsgData.replace("?", "");
          }
          if (aimsgData[i] === "？") {
            aimsgData = aimsgData.replace("？", "");
          }
          if (aimsgData[i] === "%") {
            aimsgData = aimsgData.replace("%", "%25");
          }
          if (aimsgData[i] === "&") {
            aimsgData = aimsgData.replace("&", "%26");
          }
          if (aimsgData[i] === "+") {
            aimsgData = aimsgData.replace("+", "%2B");
          }
          if (aimsgData[i] === "/") {
            aimsgData = aimsgData.replace("/", "%2F");
          }
          if (aimsgData[i] === "#") {
            aimsgData = aimsgData.replace("#", "%23");
          }
        }
        if (!aimsgData) {
          return;
        } else {
          if (this.aiRequest) {
            this.messageTip = "已有问题在途中~请等候";
            this.messageTipOpen();
          } else {
            this.requestLoading = true;
            this.requestEnd = false;
            this.aiRequest = true;
            this.chatList.push({
              type: "user",
              content: this.aimsg
            });
            this.moveScroll();
            let indexc = this.chatList.length;
            var text = ""; //接收返回的内容
            var url = "";
            if (this.isNewChat) {
              url =
                "/api/common/baidubce/questions?isNewChat=1&question=" +
                aimsgData; //建立长连接的接口
            } else {
              url =
                "/api/common/baidubce/questions?isNewChat=0&question=" +
                aimsgData; //建立长连接的接口
            }
            const eventSource = new EventSourcePolyfill(url, {
              method: "POST",
              headers: {
                Authorization: localStorage.getItem("token"),
                "Cache-Control": "no-cache",
                "X-Accel-Buffering": "no"
              }
            });
            eventSource.onopen = event => {
              this.sse = event.target;
            };
            eventSource.onmessage = event => {
              this.requestLoading = false;
              if (event.lastEventId == "[TOKENS]") {
                //结束前会返回tokens
                text = text + event.data;
                return;
              }
              if (event.data == "[DONE]") {
                // 结束
                return;
              }
              let json_data = JSON.parse(event.data);
              if (json_data.result == null || json_data.result == "null") {
                return;
              }
              text = text + json_data.result;
              this.chatList.splice(indexc, 1, {
                content: text,
                type: "bot",
                islike: false,
                isDisLike: false,
                status: json_data.is_end
              });
              this.moveScroll();
              if (json_data.is_end) {
                this.queryBaiduBce();
                this.queryThreeQuestions();
                this.aiRequest = false;
                this.requestEnd = true;
                this.isNewChat = false;
                event.target.close();
              }
            };
            eventSource.onerror = event => {
              console.log("onerror", event);
              if (event.readyState === EventSource.CLOSED) {
                console.log("connection is closed");
              } else {
                console.log("Error occured11111", event);
              }
              this.aiRequest = false;
              this.requestEnd = false;
              this.requestLoading = false;
              this.isNewChat = false;
              event.target.close();
            };
            eventSource.addEventListener("message", event => {});
            this.aimsg = null;
            if (e.preventDefault) {
              e.preventDefault();
            } else {
              window.event.value = false;
            }
          }
        }
      }
    },
    moveScroll() {
      this.$nextTick(() => {
        this.$refs.contentbox.scrollTop = this.$refs.contentbox.scrollHeight;
      });
    },
    // 设置弹出消息自动消失
    messageTipOpen() {
      this.messageTipShow = true;
      this.timer = setTimeout(() => {
        this.messageTipShow = false;
      }, 1000);
    },
    // 复制
    copyToClipboard(text) {
      // 检查浏览器是否支持 Clipboard API
      if (!navigator.clipboard) {
        // 如果不支持，则使用传统的 document.execCommand("copy") 方式
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        this.$notify({
          title: "复制成功",
          message: "",
          duration: 1000,
          type: "success"
        });
        return;
      }
      // 使用 Clipboard API 复制内容到剪切板
      navigator.clipboard.writeText(text).then(() => {
        this.$notify({
          title: "复制成功",
          message: "",
          duration: 1000,
          type: "success"
        });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.aibox {
  width: 100%;
  min-width: 450px;
  max-width: 70vw;
  position: fixed;
  display: flex;
  flex-direction: row;
  height: 100%;
  min-height: 500px;
  border-radius: 10px 0 0 10px;
  box-shadow: 1px 0 2px 2px #ecf5ff;
  top: 0;
  right: 0;
  z-index: 999 !important;
  background: linear-gradient(276.46deg, #d9efff -15.94%, #ff91bc 100.8%),
    linear-gradient(0deg, #fff, #fff);
  box-sizing: border-box;
}
.aibox_m {
  width: 100vw;
  position: fixed;
  display: flex;
  flex-direction: row;
  height: 100%;
  min-height: 500px;
  border-radius: 10px 0 0 10px;
  box-shadow: 1px 0 2px 2px #ecf5ff;
  top: 0;
  right: 0;
  z-index: 999 !important;
  background: linear-gradient(276.46deg, #d9efff -15.94%, #ff91bc 100.8%),
    linear-gradient(0deg, #fff, #fff);
  box-sizing: border-box;
}

#aibtn3 {
  position: fixed;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #a2f3fb;
  right: 20px;
  bottom: 100px;
  z-index: 9999 !important;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  display: flex;
  text-align: center;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  img {
    width: 40%;
  }

  &:hover {
    transform: scale(1.3);
    transition: all 0.4s;
  }

  @keyframes aiaction2 {
    100% {
      scale: (1.3);
    }
  }

  @keyframes aiaction {
    0%,
    50% {
      transform: translateY(-20px);
    }

    25%,
    75% {
      transform: translateY(0);
    }
  }
}

.left {
  width: 200px;
  border-right: 2px solid #fff;
}

.addchat {
  height: 80px;
  width: 250px;
  position: absolute;
  bottom: 0;
  padding: 20px 20px 20px 25px;

  .addbtn {
    width: 150px;
    height: 40px;
    border: 5px solid transparent;
    border-radius: 10px;
    background-image: linear-gradient(to right, #fff, #fff),
      linear-gradient(to right, red, #578aef);
    background-color: #d4f1ff;
  }
}

.border {
  width: 3px;
  background: white;
}
.right {
  // max-width: 450px;
  width: 100%;
  height: 100%;

  .messageTip {
    // width: 150Px;
    padding: 0 15px;
    height: 60px;
    line-height: 60px;
    position: absolute;
    text-align: center;
    z-index: 999;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 8px;
    background-color: #be3c6e;
    color: #fff;
    font-weight: bold;
  }
}

.title {
  border-radius: 8px 0px 0px 0px;
  position: relative;
  // top: 0;
  color: #fff;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: linear-gradient(90deg, #a9b7c5 50%, #f6488b);

  .chatnum {
    position: absolute;
    left: 20px;
    font-size: 13px;

    span {
      padding: 10px 16px;
      background-color: #be3c6e;
      border-radius: 8px;
      box-shadow: 0 0.01875rem 0.05625rem rgba(0, 0, 0, 0.12),
        0 0.1rem 0.225rem rgba(0, 0, 0, 0.16);
      margin-right: 10px;
      cursor: pointer;
    }
  }

  .top-minus {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: 600;
    position: absolute;
    right: 40px;
    top: 0;
    cursor: pointer;
    color: #fff;
  }

  .top-close {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: 600;
    position: absolute;
    right: 10px;
    top: 0;
    cursor: pointer;
    color: #fff;
  }
}

.contentbox {
  box-sizing: border-box;
  width: 100%;
  height: calc(100% - 215px);
  flex-grow: 2;
  overflow: hidden;
  overflow-y: scroll;
}

.chat-list {
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 0 auto;
  margin-top: 1rem;
  margin-bottom: 1rem;

  .tastrule_center {
    white-space: pre-wrap;
  }

  > div {
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
    letter-spacing: 0.5px;
    font-weight: 500;
    font-size: 14px;
    font-family: Verdana, Arial, Helvetica, sans-serif;
    box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.12),
      0px 1.6px 3.6px rgba(0, 0, 0, 0.16);
    border-radius: 12px;

    .bot {
      align-self: flex-end;
      border-radius: 12px;
      padding: 10px 16px;
      opacity: 0.8;
      border-radius: 12px 12px 0 0;
      font-size: 0.9rem;
      font-family: FZLanTingHei-L-GBK;
      font-weight: 400;
      text-align: start;
      border-bottom: 1px;
    }

    .user {
      align-self: flex-start;
      padding: 10px 16px;
      opacity: 0.8;
      border-radius: 12px 12px 0 0;
      font-size: 0.9rem;
      font-family: FZLanTingHei-L-GBK;
      font-weight: 400;
      text-align: start;
      border-bottom: 1px;
    }

    .img1 {
      width: 50px;
    }

    .img2 {
      width: 2rem;
      height: 2rem;
      margin-left: 1rem;
    }
  }

  > .botbox {
    align-self: flex-start;
    background: #fff;
    color: #000;
    margin-inline-end: 50px;
    .aiOperate {
      padding: 10px 16px;
      border-top: 1px solid rgba(0, 0, 0, 0.1);

      > div {
        height: 15px;
        display: flex;
        gap: 15px;

        > img {
          height: 100%;
          cursor: pointer;
        }
      }
    }
  }

  > .userbox {
    border-radius: 12px;
    align-self: flex-end;
    margin-inline-start: 50px;
    color: #fff;
    background: linear-gradient(130deg, #be3c6e 20%, #ce5986 77.5%);
  }

  > .kfbox {
    align-self: flex-start;
    background: #fff;
    color: #000;
    margin-inline-end: 50px;
    border-radius: 12px;
    > .codeimg {
      align-self: flex-end;
      border-radius: 12px;
      padding: 10px 16px;
      opacity: 0.8;
      border-radius: 12px 12px 0 0;
      font-size: 0.9rem;
      font-family: FZLanTingHei-L-GBK;
      font-weight: 400;
      text-align: start;
      border-bottom: 1px;
    }
  }

  .loadingview {
    box-shadow: none !important;
  }

  .threequestion {
    display: flex;
    position: relative;
    gap: 0.9375rem;
    box-shadow: none;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-end;
    > div {
      padding: 0px 10px;
      height: 28px;
      line-height: 28px;
      border-radius: 8px;
      background-color: white;
      border: 1px solid #742f6b;
      cursor: pointer;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    > img {
      height: 28px;
    }
  }

  .loadingbox {
    width: 50px;
  }

  .loadingbox > div {
    width: 10px;
    height: 10px;
    background-color: #33e5e5;
    border-radius: 50%;
    display: inline-block;
    animation: action 1.5s infinite ease-in-out;
    animation-fill-mode: both;
  }

  .loadingbox .point1 {
    animation-delay: -0.3s;
  }

  .loadingbox .point2 {
    animation-delay: -0.1s;
  }

  @keyframes action {
    0%,
    80%,
    100% {
      transform: scale(0);
    }

    40% {
      transform: scale(1);
    }
  }
}

.bottombox {
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  line-height: 1.5;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  .bottombox_inner {
    width: 100%;
    height: 100px;
    border-radius: 12px;
    background-color: #fff;
    background-image: none;
    border: 0.0625rem solid #dcdfe6;
    box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.12),
      0px 1.6px 3.6px rgba(0, 0, 0, 0.16);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

    /deep/.el-icon-s-promotion {
      color: rgba(190, 60, 110, 1);
      cursor: pointer;
      font-size: 16px;
      position: absolute;
      bottom: 48px;
      right: 30px;
    }
  }

  .aitips {
    color: #b39898;
    text-align: center;
    font-size: 12px;
    margin-top: 8px;
  }
}

/deep/ .el-textarea .el-input__count {
  color: #666666;
  position: absolute;
  bottom: -20px;
  right: 35px;
  font-size: 12px;
}

/deep/ textarea {
  border-radius: 12px !important;
  min-height: 70px !important;
  max-height: 70px !important;
  border: none;
}

/* 1.过渡动画 */
@keyframes axisX {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0px);
  }
}

@keyframes axisX2 {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes axisX3 {
  0% {
    opacity: 0;
  }

  70% {
    opacity: 0;
  }

  80% {
    opacity: 0.7;
  }

  90% {
    opacity: 0.9;
  }

  100% {
    opacity: 1;
  }
}

@keyframes widthX {
  from {
    width: 0px;
  }

  to {
    width: 200px;
  }
}

@keyframes opacityLing {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

/* 2. 过渡类名 */
/* 开始 */
.ai1-enter-active {
  animation: axisX 1s;
}

/* 结束 */
.ai1-leave-active {
  animation: axisX 0.5s reverse;
}

/* 开始 */
.ai2-enter-active {
  animation: axisX 1s;
}

/* 结束 */
.ai2-leave-active {
  animation: axisX 0.5s reverse;
}

.ai3-enter-active {
  animation: axisX3 1s;
}

/* 结束 */
.ai3-leave-active {
  animation: axisX2 0s reverse;
}

.left-enter-active {
  animation: widthX 0.7s;
}

.left-leave-active {
  animation: widthX 0.7s reverse;
}

.close-enter-active {
}

.close-leave-active {
  animation: opacityLing 1s;
}

::-webkit-scrollbar {
  width: 0px !important;
  height: 0px !important;
  background-color: #fff;
}
</style>